import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { auth } from '@/config/firebaseconfig'; // Import from your config file

const state = {
  user: null,
  isAuthenticated: false,
  authIsReady: false
};

const mutations = {
  setUser(state, payload) {
    state.user = payload;
    state.isAuthenticated = !!payload;
  },
  setAuthIsReady(state, payload) {
    state.authIsReady = payload;
  }
};

const actions = {
  async login({ commit }, { email, password }) {
    const authInstance = getAuth();
    const userCredential = await signInWithEmailAndPassword(authInstance, email, password);
    if (userCredential.user) {
      commit('setUser', userCredential.user);
    } else {
      throw new Error('Login failed');
    }
  },
  async logout({ commit }) {
    await signOut(auth);
    commit('setUser', null);
  },
  // This action is crucial for keeping the user logged in across page reloads
  initAuth({ commit }) {
    onAuthStateChanged(auth, (user) => {
      commit('setUser', user);
      commit('setAuthIsReady', true);
    });
  }
};

const getters = {
  user: (state) => state.user,
  isAuthenticated: (state) => state.isAuthenticated,
  authIsReady: (state) => state.authIsReady
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};